var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Input from './Input';
import { withBlank } from '../utils';
var DataEdit = function DataEdit(_ref) {
  var labels = _ref.labels,
    properties = _ref.properties;
  var _properties$title = properties.title,
    title = _properties$title === undefined ? {} : _properties$title,
    _properties$subtitle = properties.subtitle,
    subtitle = _properties$subtitle === undefined ? {} : _properties$subtitle,
    _properties$source = properties.source,
    source = _properties$source === undefined ? {} : _properties$source,
    _properties$logo = properties.logo,
    logo = _properties$logo === undefined ? {} : _properties$logo,
    _properties$copyright = properties.copyright,
    copyright = _properties$copyright === undefined ? {} : _properties$copyright;
  var resetLabel = R.prop('reset', labels);
  return React.createElement(Grid, {
    'data-testid': 'data-edit-test-id',
    container: true,
    spacing: 1
  }, React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Typography, {
    variant: 'h6'
  }, 'Information')), R.prop('isActive', title) && React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      minWidth: 220
    }
  }, React.createElement(Input, _extends({
    fullWidth: true,
    label: R.prop('title', labels),
    resetLabel: resetLabel
  }, R.dissoc('isDefault', title)))), R.prop('isActive', subtitle) && React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      minWidth: 220
    }
  }, React.createElement(Input, _extends({
    fullWidth: true,
    label: R.prop('subtitle', labels),
    resetLabel: resetLabel
  }, R.dissoc('isDefault', subtitle)))), R.prop('isActive', source) && React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      minWidth: 220
    }
  }, React.createElement(Input, _extends({
    fullWidth: true,
    label: R.prop('source', labels),
    resetLabel: resetLabel
  }, R.dissoc('isDefault', source)))), React.createElement(Grid, {
    item: true,
    container: true,
    xs: 12,
    justifyContent: 'space-around'
  }, R.map(function (item) {
    if (R.pipe(R.prop('isActive'), R.not)(item)) return;
    var id = R.prop('id')(item);
    return React.createElement(Grid, {
      item: true,
      key: id
    }, React.createElement(FormControlLabel, {
      control: React.createElement(Checkbox, _extends({
        color: 'primary',
        inputProps: {
          'aria-label': R.prop(id)(labels)
        }
      }, R.omit(['isActive'])(item))),
      label: R.prop(id)(labels)
    }));
  })([logo, copyright])));
};
DataEdit.propTypes = process.env.NODE_ENV !== "production" ? {
  labels: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    source: PropTypes.string,
    logo: PropTypes.string,
    copyright: PropTypes.string,
    reset: PropTypes.string
  }),
  properties: PropTypes.shape({
    title: PropTypes.shape({
      id: PropTypes.string,
      isActive: PropTypes.bool,
      onSubmit: PropTypes.func,
      onReset: PropTypes.func,
      value: PropTypes.string
    }),
    subtitle: PropTypes.shape({
      id: PropTypes.string,
      isActive: PropTypes.bool,
      onSubmit: PropTypes.func,
      onReset: PropTypes.func,
      value: PropTypes.string
    }),
    source: PropTypes.shape({
      id: PropTypes.string,
      isActive: PropTypes.bool,
      onSubmit: PropTypes.func,
      onReset: PropTypes.func,
      value: PropTypes.string
    }),
    logo: PropTypes.shape({
      id: PropTypes.string,
      isActive: PropTypes.bool,
      onChange: PropTypes.func,
      checked: PropTypes.bool
    }),
    copyright: PropTypes.shape({
      id: PropTypes.string,
      isActive: PropTypes.bool,
      onChange: PropTypes.func,
      checked: PropTypes.bool
    })
  })
} : {};
var isAllInactive = R.pipe(R.pluck('isActive'), R.all(R.identity), R.not);
export default withBlank(function (_ref2) {
  var isBlank = _ref2.isBlank,
    _ref2$properties = _ref2.properties,
    properties = _ref2$properties === undefined ? {} : _ref2$properties;
  return {
    isBlank: R.any(R.identity)([isBlank, R.isEmpty(properties), isAllInactive(properties)])
  };
})(DataEdit);